import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { Formik, Field, Form, ErrorMessage } from "formik";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import * as Yup from "yup";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Label,
    Button,
} from "reactstrap";

import {
    addApplicant,
    applyCoupon,
    getClubs,
} from "store/actions";

//Import Date Picker
import "react-datepicker/dist/react-datepicker.css";

import DefaultModal from "components/Common/DefaultModal";
import Switch from "components/Common/Switch";

class AddApplicant extends Component {
    constructor() {
        super();
        this.state = {
            selectedFiles: [],
            eventImage: null,
            clubsFiltered: [],
            clubsSelected: [],
            value: [],
            clubError: false,
            confirmModal: false,
            emailOrNotification: { label: "Email", value: 'Email' },
            dataToSend: null,
            clubSelected: { label: "Select Club", value: 0 },
            onTrial: false
        };
        this.handleAcceptedFiles.bind(this);
        this.showSuccessToast = this.showSuccessToast.bind(this);

    }

    filterClubs = () => {
        const { clubs } = this.props;
        return clubs.map(item => ({ label: item.name, value: item.id }));
    };

    handleEmailNotificationSelect = value => {
        this.setState({
            emailOrNotification: value,
        })

    }


    showSuccessToast(message, autoClose, success) {
        if (success) {
            toast.success(message, {
                position: "top-right",
                autoClose: autoClose,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setTimeout(() => {
                this.props.history.push('/applicants')
            }, 2000);
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: autoClose,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }

    }

    onFileUploaded(file) {
        this.setState({ eventImage: file.url });
    }

    componentDidMount() {
        const {
            onGetClubs
        } = this.props;
        onGetClubs();
        this.setState({
            clubsFiltered: [
                {
                    label: "Clubs",
                    options: this.filterClubs(),
                },
            ],
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const { clubs } = this.props
        if (clubs !== prevProps.clubs) {
            this.setState({
                clubsFiltered: [
                    {
                        label: "Clubs",
                        options: this.filterClubs(),
                    },
                ],
            });
        }
    }



    handleAcceptedFiles = files => {
        files.map(file =>
            Object.assign(file, {
                preview: URL.createObjectURL(file),
                formattedSize: this.formatBytes(file.size),
            })
        );

        this.setState({ selectedFiles: files });
    };

    onChange = (newValue) => {
        this.setState({
            value: newValue,
            clubError: false
        })
    };

    handleTrial = () => {
        this.setState({
            onTrial: !this.state.onTrial,
        });
    };


    handleConfirm = () => {
        const { onAddApplicant } = this.props;
        const { dataToSend } = this.state;
        onAddApplicant({ ...dataToSend, showSuccessToast: this.showSuccessToast })
        this.setState({
            confirmModal: false,
        });
    };

    formatBytes = (bytes, decimals = 2) => {
        if (bytes === 0) return "0 Bytes";
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    };

    handleCouponSelect = location => {
        this.setState({
            clubSelected: location,
            clubError: false
        })
    }


    render() {

        const { confirmModal } = this.state

        return (
            <React.Fragment>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <DefaultModal
                    title={'Are you sure you want to add this applicant?'}
                    description={'You will not be able to revert this!'}
                    show={confirmModal}
                    onSendClick={this.handleConfirm}
                    onCloseClick={() => this.setState({ confirmModal: false })}
                />
                <div className="page-content">
                    <MetaTags>
                        <title> Add Applicant | Groundfloor</title>
                    </MetaTags>
                    <Container fluid>
                        <Row>
                            <Col lg="12">
                                <Card >
                                    <CardBody style={{ height: '80vh' }}>
                                        <div style={{ display: 'flex', }}>
                                            <CardTitle style={{ marginRight: 43 }} className="mb-4">Add Applicant</CardTitle>
                                        </div>
                                        <Formik
                                            enableReinitialize={true}
                                            initialValues={
                                                {
                                                    firstName: "",
                                                    lastName: "",
                                                    email: "",
                                                }
                                            }
                                            validationSchema={Yup.object().shape({
                                                firstName: Yup.string().optional(),
                                                lastName: Yup.string().optional(),
                                                email: Yup.string().required("Please Enter Email"),

                                            })}

                                            onSubmit={values => {
                                                if (this.state.clubSelected.value === 0) {
                                                    this.setState({
                                                        clubError: true
                                                    })
                                                } else {
                                                    this.setState({
                                                        dataToSend: {
                                                            firstName: values.firstName,
                                                            lastName: values.lastName,
                                                            email: values.email,
                                                            trial: this.state.onTrial ? 1 : 0,
                                                            mainClubId: this.state.clubSelected.value,
                                                        },
                                                        confirmModal: true
                                                    })
                                                }
                                            }}
                                        >
                                            {({ errors, status, touched }) => (
                                                <React.Fragment>
                                                    <Form>
                                                        <Row className="mb-4">
                                                            <Label
                                                                htmlFor="firstName"
                                                                className="col-form-label col-lg-2"
                                                            >
                                                                First Name
                                                            </Label>
                                                            <Col lg="4">
                                                                <Field
                                                                    name="firstName"
                                                                    type="text"
                                                                    placeholder="First Name"
                                                                    className={
                                                                        "form-control" +
                                                                        (errors.firstName && touched.firstName
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }
                                                                />
                                                            </Col>
                                                        </Row>
                                                        <Row className="mb-4">
                                                            <Label
                                                                htmlFor="lastName"
                                                                className="col-form-label col-lg-2"
                                                            >
                                                                Last Name
                                                            </Label>
                                                            <Col lg="4">
                                                                <Field
                                                                    name="lastName"
                                                                    type="text"
                                                                    placeholder="Last Name"
                                                                    className={
                                                                        "form-control" +
                                                                        (errors.lastName && touched.lastName
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }
                                                                />
                                                            </Col>
                                                        </Row>
                                                        <Row className="mb-4">
                                                            <Label
                                                                htmlFor="email"
                                                                className="col-form-label col-lg-2"
                                                            >
                                                                Email
                                                            </Label>
                                                            <Col lg="4">
                                                                <Field
                                                                    name="email"
                                                                    type="text"
                                                                    placeholder="Email..."
                                                                    className={
                                                                        "form-control" +
                                                                        (errors.email && touched.email
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }
                                                                />
                                                                <ErrorMessage
                                                                    name="email"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </Col>
                                                        </Row>

                                                        <Row className="mb-4 mt-4">
                                                            <Label className="col-form-label col-lg-2">
                                                                Select Club
                                                            </Label>
                                                            <Col lg="4">
                                                                <Select
                                                                    onChange={
                                                                        this.handleCouponSelect
                                                                    }
                                                                    options={this.state.clubsFiltered}
                                                                    value={this.state.clubSelected}
                                                                    defaultValue={{ label: "Select Club", value: 0 }}
                                                                    classNamePrefix="select2-selection"
                                                                />
                                                                {this.state.clubError && (
                                                                    <span
                                                                        style={{
                                                                            color: "red",
                                                                        }}
                                                                    >
                                                                        Please Select Club
                                                                    </span>
                                                                )}
                                                            </Col>
                                                        </Row>
                                                        <Row className="mb-4">
                                                            <Label
                                                                className="col-form-label col-lg-2"
                                                            >
                                                                On Trial
                                                            </Label>
                                                            <Col lg="10">
                                                                <div className="form-check">
                                                                    <Switch active={this.state.onTrial} parentFunc={this.handleTrial} />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row className="justify-content-end">
                                                            <Col lg="10">
                                                                <Button type="submit" color="primary">
                                                                    Add Applicant
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    </Form>
                                                </React.Fragment>
                                            )}
                                        </Formik>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

AddApplicant.propTypes = {
    onGetClubs: PropTypes.func,
    onAddApplicant: PropTypes.func,
    clubs: PropTypes.array,
    history: PropTypes.shape({
        go: PropTypes.func.isRequired,
        push: PropTypes.func.isRequired,
    }),
};

const mapStateToProps = ({ system, members }) => ({
    clubs: system.clubs,
});

const mapDispatchToProps = dispatch => ({
    onGetClubs: () => dispatch(getClubs()),
    onAddApplicant: (data) => dispatch(addApplicant(data)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(AddApplicant));